module.exports = __webpack_public_path__ + "img/bentoboxrechts.bd4ee62a.jpg";